export class NotificacaoApi {
    path = '/adm/notificacoes';

    async list(filters = null) {
        try {
            const response = await axios.get(`${this.path}/list`, {
                params: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching notificacao list:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`${this.path}/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching notificacao:', error);
            throw error;
        }
    }

    async store(data) {
        try {
            const response = await axios.post(`${this.path}`, data);

            return response.data;
        } catch (error) {
            console.error('Error store notificacao:', error);
            throw error;
        }
    }

    async update(data, id) {
        try {
            const response = await axios.put(`${this.path}/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error updating notificacao:', error);
            throw error;
        }
    }

    async destroy(id) {
        try {
            const response = await axios.delete(`${this.path}/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error deleting notificacao:', error);
            throw error;
        }
    }

    async submitNotification(id) {
        try {
            const response = await axios.post(`${this.path}/${id}/enviar`);

            return response.data;
        } catch (error) {
            console.error('Error submiting notification:', error);
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/api/NotificacaoApi.js